import { useAppConfig } from "@/api/app-config/useAppConfig";

interface ITtsConfig {
  isTtsEnabled: boolean;
  isExternalServiceForTts: boolean;
  ttsVoices: string[];
  isLoading: boolean;
}

export const useTtsConfig = (): ITtsConfig => {
  const { data, isLoading } = useAppConfig();
  return {
    isTtsEnabled: data?.isTtsEnabled ?? false,
    isExternalServiceForTts: data?.isExternalServiceForTts ?? false,
    ttsVoices: data?.ttsVoices ?? [],
    isLoading,
  };
};
